import { BaseSvgIcon } from './BaseSvgIcon'

export const PeeIcon = (props: any) => {
  const { width = 80, height = 80, fill = '#fcf0ad', ...rest } = props

  return (
    <BaseSvgIcon width={width} height={height} fill={fill} viewBox="0 0 80 80" {...rest}>
      <mask
        id="mask0_404_183"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M0 7.62939e-06H80V80H0V7.62939e-06Z" fill="white" />
      </mask>
      <g mask="url(#mask0_404_183)">
        <path
          d="M68.2829 54.4246L53.8911 19.884C53.1957 18.2154 50.8318 18.2154 50.1365 19.884L35.7448 54.4246C30.9075 66.0338 39.4371 78.8284 52.0139 78.8284C64.5906 78.8284 73.1201 66.0338 68.2829 54.4246Z"
          fill="#9BE8FD"
        />
        <path
          d="M45.2224 54.4246L56.7527 26.7518L53.891 19.884C53.1958 18.2154 50.8319 18.2154 50.1366 19.884L35.7449 54.4246C30.9075 66.0338 39.4372 78.8284 52.0139 78.8284C53.6711 78.8284 55.2574 78.6041 56.7527 78.1918C46.8997 75.4749 41.0225 64.5042 45.2224 54.4246Z"
          fill="#62DDFC"
        />
        <path
          d="M30.4595 39.8641L21.9223 19.3749C21.5099 18.3851 20.1077 18.3851 19.6952 19.3749L11.1582 39.8641C8.28868 46.7507 13.3484 54.3402 20.8087 54.3402C28.2691 54.3402 33.3288 46.7507 30.4595 39.8641Z"
          fill="#9BE8FD"
        />
        <path
          d="M17.6596 39.6127L24.0071 24.3783L21.9223 19.3748C21.5099 18.385 20.1077 18.385 19.6952 19.3748L11.1582 39.8641C8.28868 46.7506 13.3484 54.3401 20.8088 54.3401C22.1038 54.3401 23.3266 54.1109 24.4481 53.6969C18.6341 52.0614 15.1756 45.5742 17.6596 39.6127Z"
          fill="#62DDFC"
        />
        <path
          d="M40.9688 13.3976L36.0527 1.59912C35.8154 1.02912 35.0079 1.02912 34.7704 1.59912L29.8545 13.3976C28.2021 17.363 31.1156 21.7333 35.4117 21.7333C39.7076 21.7333 42.621 17.363 40.9688 13.3976Z"
          fill="#9BE8FD"
        />
        <path
          d="M36.1044 13.3975L38.5365 7.56031L36.0527 1.59922C35.8152 1.02921 35.0077 1.02921 34.7704 1.59922L29.8544 13.3975C28.2021 17.363 31.1155 21.7333 35.4115 21.7333C36.5765 21.7333 37.6384 21.41 38.5365 20.8623C36.1226 19.3908 34.9002 16.2877 36.1044 13.3975Z"
          fill="#62DDFC"
        />
        <path
          d="M68.2829 54.4246L53.8911 19.884C53.1957 18.2154 50.8318 18.2154 50.1365 19.884L35.7448 54.4246C30.9075 66.0338 39.4371 78.8284 52.0139 78.8284C64.5906 78.8284 73.1201 66.0338 68.2829 54.4246Z"
          stroke="black"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M58.903 71.0963C60.1037 70.2466 61.1584 69.1642 62.0173 67.8758C64.3077 64.4398 64.7105 60.2831 63.1224 56.4716"
          stroke="black"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.6455 48.5718C24.2458 48.1469 24.7731 47.6057 25.2027 46.9615C26.3478 45.2437 26.5492 43.1652 25.7552 41.2594"
          stroke="black"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.5432 53.9839C29.434 52.4085 32.9617 45.8693 30.4595 39.8641L21.9223 19.3749C21.5098 18.385 20.1078 18.385 19.6953 19.3749L11.1579 39.8641C8.65588 45.8693 12.1835 52.4085 18.0745 53.9839"
          stroke="black"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.59 12.4885L36.0527 1.59928C35.8152 1.02928 35.0077 1.02928 34.7704 1.59928L29.8543 13.3976C28.2021 17.363 31.1155 21.7333 35.4115 21.7333C38.0241 21.7333 40.123 20.1158 40.9969 17.9572"
          stroke="black"
          strokeWidth="2.34375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </BaseSvgIcon>
  )
}
